export default function teststatus(status) {
  if (status === 'NO_DATA') {
    return 'No Data';
  } if (status === 'PASSING') {
    return 'Passing';
  } if (status === 'FAILING') {
    return 'Failing';
  }
  return 'No Data';
}
